/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleEs() {
  return (
    <>
      <div>
        <p className="page-title">
          Política de Protección de Datos del Portal Web de Robótica
        </p>
        <h2 className="heading-title">
          I. Nombre y dirección del responsable del tratamiento y del delegado
          de protección de datos
        </h2>

        <p className="my-20">
          Nombre y datos de contacto del responsable del tratamiento de datos:
        </p>
        <p>KÄRCHER, S.A.</p>
        <p>Pol. Ind. Font del Radium</p>
        <p>Calle Josep Trueta nº 7</p>
        <p>08403 Granollers</p>
        <p>93 846 44 47</p>
        <p>
          <a
            href="mailto:ml-es10-karcher.central@karcher.com
">
            ml-es10-karcher.central@karcher.com
          </a>
        </p>

        <p className="my-10">
          (En adelante: KÄRCHER) procederá de conformidad con las disposiciones
          legales en lo que respecta a todas las operaciones de tratamiento de
          datos (por ejemplo, recogida, tratamiento y transmisión).
        </p>

        <p className="my-10">
          La siguiente política le ofrece una visión general del tipo de datos
          que se recopilan en y a través de nuestro portal web en&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(en adelante: plataforma) y cómo se procesan, qué medidas de
          seguridad toma KÄRCHER para proteger sus datos y cómo puede ejercer
          sus derechos.
        </p>

        <p className="my-10">
          Si tiene alguna pregunta sobre la protección de datos y sus derechos
          como interesado, puede ponerse en contacto con el responsable de
          protección de datos de KÄRCHER en:
        </p>

        <p>KÄRCHER, S.A.</p>
        <p>Delegado de Protección de Datos</p>
        <p>Pol. Ind. Font del Radium</p>
        <p>Calle Josep Trueta nº 7</p>
        <p>08403 Granollers</p>
        <p>
          <a href="mailto:ml-es10-protecciondatos@karcher.com">
            ml-es10-protecciondatos@karcher.com
          </a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Información general sobre el tratamiento de datos</h2>

        <h3>1. Ámbito de aplicación del tratamiento de datos personales</h3>
        <p>
          A menos que se indique lo contrario, procesamos sus datos personales
          como usuario de nuestra plataforma (en adelante: Interesado) para
          poder ofrecerle y proporcionarle una plataforma funcional y fácil de
          usar y nuestros respectivos servicios.
        </p>

        <h3>2. Base jurídica para el tratamiento de datos personales</h3>
        <p>
          En la medida en que obtengamos el consentimiento del interesado para
          el tratamiento de los datos personales, el art. 6 (1) (a) del
          Reglamento General de Protección de Datos (RGPD) sirve como base
          jurídica.
        </p>

        <p className="mt-10">
          Si el tratamiento de datos personales es necesario para el uso de la
          plataforma, el Art. 6 (1) (b) RGPD sirve como base legal. Esto también
          se aplica a las operaciones de tratamiento que son necesarias para la
          aplicación de medidas precontractuales.
        </p>
        <p>
          En la medida en que el tratamiento de datos personales sea necesario
          para el cumplimiento de una obligación legal a la que esté sujeta
          nuestra empresa, el Art. 6 (1) (c) RGPD sirve como base jurídica.
        </p>

        <p className="mt-10">
          Si el tratamiento es necesario para proteger un interés legítimo de
          nuestra empresa o de un tercero y los intereses, derechos y libertades
          fundamentales del interesado no prevalecen sobre dicho interés, el
          Art. 6 (1) (f) RGPD sirve de base jurídica para el tratamiento.
        </p>

        <h3>3. Supresión de datos y periodo de almacenamiento</h3>
        <p>
          Salvo que se indique lo contrario, los datos personales se bloquearán
          o borrarán en cuanto deje de ser aplicable la finalidad del
          almacenamiento.
        </p>

        <p className="mt-10">
          Además, los datos podrán almacenarse si así lo dispone el legislador
          europeo o nacional en reglamentos, leyes u otras disposiciones de la
          UE a las que esté sujeto el responsable del tratamiento. Los datos
          también se bloquearán o borrarán si expira un período de
          almacenamiento así prescrito, a menos que sea necesario seguir
          almacenando los datos para la celebración o ejecución de un contrato.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Puesta a disposición de la plataforma</h2>

        <h3>1. Descripción y alcance del tratamiento de datos</h3>
        <p>
          Cada vez que se accede a nuestra plataforma, nuestro sistema recopila
          automáticamente datos e información del sistema informático del
          ordenador que accede.
        </p>

        <p className="mt-10">Se recogen los siguientes datos:</p>

        <ul>
          <li>Fecha y hora de la solicitud</li>
          <li>Nombre del archivo solicitado</li>
          <li>Hora del último inicio de sesión</li>
          <li>Página desde la que se solicitó el archivo</li>
          <li>
            Estado del acceso (archivo transferido, archivo no encontrado, etc.)
          </li>
          <li>Navegador web y sistema operativo utilizado</li>
          <li>Dirección IP completa del ordenador solicitante</li>
          <li>Volumen de datos transferidos</li>
          <li>Datos de robótica, información de la ruta del robot y mapas.</li>
        </ul>

        <p>
          Los datos también se almacenan en los archivos de registro de nuestro
          sistema.
        </p>

        <h3>2. Base jurídica para el tratamiento de datos</h3>
        <p>
          La base jurídica para el almacenamiento temporal de los datos y los
          archivos de registro es el Art. 6 (1) (f) RGPD.
        </p>

        <h3>3. Finalidad del tratamiento de datos</h3>
        <p>
          El almacenamiento temporal de la dirección IP por parte del sistema es
          necesario para permitir la entrega de la plataforma al ordenador del
          usuario. Para ello, la dirección IP del usuario debe permanecer
          almacenada mientras dure la sesión.
        </p>

        <p className="mt-10">
          El almacenamiento en archivos de registro se lleva a cabo para
          garantizar la funcionalidad de la plataforma. Además, utilizamos los
          datos para optimizar la plataforma y garantizar la seguridad de
          nuestros sistemas informáticos.
        </p>

        <p className="mt-10">
          Estos fines también constituyen nuestro interés legítimo en el
          tratamiento de datos de conformidad con el Art. 6 (1) (f) RGPD.
        </p>

        <h3>4. Duración del almacenamiento</h3>
        <p>
          Los datos se suprimirán en cuanto dejen de ser necesarios para la
          consecución de los fines para los que fueron recogidos.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Inscripción en la plataforma</h2>

        <h3>1. Descripción y alcance del tratamiento de datos</h3>
        <p>
          El registro en la plataforma y el registro de una cuenta de usuario
          son obligatorios para poder utilizar la plataforma de forma completa y
          para poder consultar los datos de la máquina procesados para el/los
          respectivo(s) aparato(s) registrado(s).
        </p>

        <p className="mt-10">
          El registro de una cuenta de usuario se realiza a través de una cuenta
          de KÄRCHER, en la que el usuario puede seleccionar una contraseña que
          utilizará junto con su dirección de correo electrónico (en adelante:
          datos de usuario). Además, puede facilitarse información adicional
          voluntaria (por ejemplo, nombre de la empresa y datos de contacto).
          Los datos se introducen en una máscara de entrada y se nos transmiten
          y almacenan.
        </p>

        <p className="mt-10">
          En la plataforma pueden almacenarse números de teléfono y direcciones
          de correo electrónico para el reenvío de mensajes por SMS o correo
          electrónico enviado desde un dispositivo. Éstos se almacenan como los
          denominados operadores, en los que se guardan el nombre, el número de
          teléfono, la dirección de correo electrónico y el dispositivo
          respectivo desde el que se reenvían los mensajes.
        </p>

        <h3>2. Base jurídica del tratamiento de datos</h3>
        <p>
          La base jurídica para el tratamiento de datos personales es la
          ejecución de un contrato (Art. 6 (1) (b) RGPD).
        </p>

        <h3>3. Finalidad del tratamiento de datos</h3>
        <p>
          La creación de una cuenta de usuario es necesaria para la asignación
          al dispositivo respectivo o el uso de las funciones proporcionadas.
          Por lo tanto, los datos también pueden procesarse cuando se utilizan
          las funciones seleccionadas por el usuario.
        </p>

        <h3>4. Duración del almacenamiento</h3>
        <p>
          Al crear una cuenta de usuario, por lo general almacenamos los datos
          personales facilitados mientras el usuario mantenga su cuenta de
          usuario o hasta que se modifiquen o eliminen los datos en la cuenta de
          usuario.
        </p>

        <p className="mt-10">
          Tenga en cuenta que la eliminación de la correspondiente cuenta de
          usuario en la plataforma puede conllevar la pérdida del acceso a la
          plataforma y del acceso a los datos almacenados.
        </p>

        <h3>5. Posibilidad de borrado</h3>
        <p>
          Los usuarios de la plataforma tienen en todo momento la posibilidad de
          modificar o borrar los datos personales allí almacenados.
        </p>

        <p className="mt-10">
          Si los datos son necesarios para la ejecución de un contrato o para la
          aplicación de medidas precontractuales, la supresión anticipada de los
          datos sólo es posible en la medida en que las obligaciones
          contractuales o legales no impidan la supresión.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Uso de cookies</h2>

        <h3>1. Descripción y alcance del tratamiento de datos</h3>
        <p>
          Nuestra plataforma utiliza cookies. Las cookies son archivos de texto
          que se almacenan en el navegador de Internet, o por el navegador de
          Internet en el sistema informático del usuario. Cuando un usuario
          accede a una plataforma, es posible que se almacene una cookie en el
          sistema operativo del usuario. Esta cookie contiene una cadena
          característica que permite identificar inequívocamente el navegador
          cuando se vuelve a llamar a la plataforma.
        </p>

        <h3>2. Base jurídica para el tratamiento de datos</h3>
        <p>
          La base jurídica para el tratamiento de datos personales mediante
          cookies funcionales o técnicamente necesarias es el art. 6 (1) (f)
          RGPD.
        </p>

        <h3>3. Finalidad del tratamiento de datos</h3>
        <p>
          La finalidad del uso de cookies técnicamente necesarias es simplificar
          el uso de la plataforma para los usuarios. Algunas funciones de
          nuestra plataforma no pueden ofrecerse sin el uso de cookies. Los
          datos de usuario recogidos mediante cookies técnicamente necesarias no
          se utilizan para crear perfiles de usuario. Estos fines también
          constituyen nuestro interés legítimo en el tratamiento de datos
          personales de conformidad con el Art. 6 (1) (f) RGPD.
        </p>

        <h3>4. Posibilidad de objeción</h3>
        <p>
          Las cookies se almacenan en el ordenador del usuario y éste las
          transmite a nuestro sitio web. Como usuario, usted también tiene pleno
          control sobre el uso de cookies. Cambiando la configuración de su
          navegador de Internet, puede desactivar o restringir la transmisión de
          cookies. Las cookies ya guardadas pueden eliminarse en cualquier
          momento. Esto también puede automatizarse. Si se desactivan las
          cookies de nuestra plataforma, puede que ya no sea posible utilizar
          todas las funciones de la plataforma en toda su extensión.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Divulgación a terceros</h2>

        <p>
          Dentro del grupo de empresas KÄRCHER, intercambiamos datos personales
          dentro del grupo en la medida en que y en la medida en que sea
          necesario para la tramitación de contratos o para la aplicación de
          medidas precontractuales de conformidad con el Art. 6 (1) (b) RGPD o
          si existe un interés justificado en una transferencia dentro del grupo
          de conformidad con el Art. 6 (1) (f) RGPD.
        </p>

        <p className="mt-10">
          Aparte de los casos mencionados explícitamente en esta política de
          protección de datos, sus datos personales solo se transmitirán a
          terceros sin su consentimiento expreso previo si así lo permite o
          exige la ley.
        </p>

        <p className="mt-10">
          Si fuera necesario para esclarecer un uso ilegal o abusivo de la
          plataforma, o para su enjuiciamiento, los datos personales se
          transmitirán a las fuerzas de seguridad u otras autoridades y, en su
          caso, a terceros perjudicados. No obstante, esto sólo se llevará a
          cabo si existen indicios de un comportamiento ilícito o abusivo.
          También estamos obligados por ley a facilitar información a
          determinados organismos públicos que lo soliciten. Se trata de las
          autoridades policiales, las autoridades que persiguen infracciones
          administrativas sujetas a multas y las autoridades fiscales.
        </p>

        <p className="mt-10">
          Cualquier revelación de datos personales está justificada por el hecho
          de que (1) el tratamiento es necesario para el cumplimiento de una
          obligación legal a la que estamos sujetos de conformidad con el Art. 6
          (1) (c) RGPD en conjunción con los requisitos legales nacionales para
          la divulgación de datos a las autoridades policiales, o (2) tenemos un
          interés legítimo en revelar los datos a los terceros antes mencionados
          si hay indicios de comportamiento abusivo o para la ejecución de
          reclamaciones legales y sus derechos e intereses en la protección de
          sus datos personales en el sentido del Art. 6 (1) (f) RGPD no
          prevalecen sobre nuestro interés legítimo.
        </p>

        <p className="mt-10">
          Para poder ofrecer los servicios de esta plataforma, se utilizan
          terceras empresas y proveedores de servicios externos. Cualquier
          empresa de terceros y proveedores de servicios externos utilizados son
          cuidadosamente seleccionados como procesadores en el ámbito del Art.
          28 (1) RGPD, controlados periódicamente y obligados contractualmente a
          procesar todos los datos personales exclusivamente de acuerdo con
          nuestras instrucciones.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Transferencia de datos a terceros países</h2>

        <p>
          Salvo que se indique lo contrario, los datos sólo se transfieren a
          organismos de países no pertenecientes a la Unión Europea (los
          denominados terceros países) en la medida en que
        </p>

        <ul>
          <li>
            sea necesario para la ejecución de sus pedidos (por ejemplo, órdenes
            de pago),
          </li>
          <li>sirva para mejorar el producto,</li>
          <li>se garantice un nivel adecuado de protección de datos, o</li>
          <li>usted nos haya dado su consentimiento.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Seguridad de los datos</h2>

        <h3>1. Medidas técnicas y organizativas generales</h3>
        <p>
          KÄRCHER ha adoptado diversas medidas de seguridad para proteger los
          datos personales de forma adecuada y en la medida apropiada. Todos los
          datos almacenados por KÄRCHER están protegidos por medidas físicas,
          técnicas y de procedimiento que restringen el acceso a la información
          a personas específicamente autorizadas de acuerdo con esta política de
          protección de datos.
        </p>

        <h3>2. Transmisión segura de datos</h3>
        <p>
          La transmisión de sus datos personales en relación con un proceso de
          pedido se codifica utilizando la tecnología estándar del sector Secure
          Socket Layer (&quot;SSL&quot;), versión de codificación SSL, o
          tecnologías comparables.
        </p>

        <h3>3. Contraseñas</h3>
        <p>
          Nunca debe revelar a terceros su contraseña de acceso a nuestra
          plataforma y, además, debe cambiarla con regularidad. Si desea salir
          de su cuenta de usuario, debe desconectarse y cerrar el navegador para
          evitar que alguien pueda acceder a ella sin autorización.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Derechos del interesado</h2>

        <h3>1. Derecho de acceso</h3>
        <p>
          De conformidad con el Art. 15 RGPD, puede solicitar acceso a sus datos
          personales que procesamos.
        </p>

        <h3>2. Derecho de oposición:</h3>
        <p>
          Tiene derecho a oponerse por motivos específicos (véase el punto 8).
        </p>

        <h3>3. Derecho de rectificación:</h3>
        <p>
          Si la información que le concierne no es (o ya no es) correcta, puede
          solicitar la rectificación de conformidad con el Art. 16 RGPD. Si sus
          datos están incompletos, puede solicitar que se completen.
        </p>

        <h3>4. Derecho de supresión:</h3>
        <p>
          Puede solicitar la eliminación de sus datos personales de conformidad
          con el Art. 17 RGPD.
        </p>

        <h3>5. Derecho a la limitación del tratamiento:</h3>
        <p>
          De conformidad con el Art. 18 del RGPD, tiene derecho a solicitar la
          restricción del tratamiento de sus datos personales.
        </p>

        <h3>6. Derecho a presentar una reclamación:</h3>
        <p>
          Si considera que el tratamiento de sus datos personales infringe la
          ley de protección de datos, tiene derecho a presentar una reclamación
          ante una autoridad de control de protección de datos de su elección o
          ante la autoridad de control de protección de datos responsable del
          responsable del tratamiento, de conformidad con el Art. 77 (1) RGPD.
        </p>

        <h3>7. Derecho a la portabilidad de los datos</h3>
        <p>
          En caso de que se cumplan los requisitos del Art. 20 (1) RGPD, usted
          tiene derecho a que los datos que procesamos automáticamente sobre la
          base de su consentimiento o en cumplimiento de un contrato sean
          entregados a usted o a terceros.
        </p>

        <h3>8. Derecho de oposición con arreglo al art. 21 (1) RGPD:</h3>
        <p>
          Tiene derecho a oponerse en cualquier momento, por motivos
          relacionados con su situación particular, al tratamiento de sus datos
          personales que se lleva a cabo sobre la base del artículo 6 (1) (f)
          RGPD. En tal caso, el responsable del tratamiento dejará de tratar
          dichos datos personales, a menos que pueda demostrar motivos legítimos
          imperiosos para el tratamiento que prevalezcan sobre los intereses,
          los derechos y las libertades del interesado o para el reconocimiento,
          el ejercicio o la defensa de un derecho en un procedimiento judicial.
        </p>
      </div>

      <div className="mt-40">
        <h2>X. Cambios en esta política de protección de datos</h2>

        <p>
          Mantenemos siempre actualizada esta política de protección de datos.
          Por lo tanto, nos reservamos el derecho a actualizarla y adaptarla de
          vez en cuando y a incorporar cualquier cambio en el tratamiento o uso
          de sus datos. La versión actual de la política de protección de datos
          está siempre disponible en la plataforma en &quot;Política de
          protección de datos&quot;.
        </p>
      </div>
    </>
  );
}
